import React from 'react';

export default function FeatureListGroupName({groupName, as: T, className}) {
	// remove sorting prefix
	const [prefix, name] = groupName.split('_', 2);
	return <T className={className}>{name ?? prefix}</T>;
}
